<template>
  <!-- <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>渠道信息设置</el-breadcrumb-item>
      <el-breadcrumb-item >渠道信息详情</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
        <el-button
      type="primary"
      icon="el-icon-arrow-left"
      @click="$router.push('/home/setting/channel')"
      >返回</el-button
    >
    </el-card>
    
  </div> -->
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item >渠道信息详情</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-button
      type="primary"
      icon="el-icon-arrow-left"
      @click="$router.push('/home/setting/channel')"
      >返回</el-button
    >
      </div>
      <el-table :data="channeInfolist" style="width: 100%"   >
      <el-table-column label="id">
        <template slot-scope="scope">
          <!-- <i class="el-icon-time"></i> -->
          <span >{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column label="账号">
        <template slot-scope="scope">
          <!-- <i class="el-icon-time"></i> -->
          <span >{{ scope.row.username }}</span>
        </template>
      </el-table-column>
      <el-table-column label="注册时间">
        <template slot-scope="scope">
          <!-- <i class="el-icon-time"></i> -->
          <span >{{ scope.row.createTime |moment }}</span>
        </template>
      </el-table-column>
      </el-table>
      <PageNation
          :total="infoTotal"
          :size="size"
          :page="page"
          @pageChanged="handlePageChanged($event)"
        ></PageNation>
      <div>
       
      
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import PageNation from "../../../../../components/pagination";
export default {
    name:'channelInfo',
  data() {
    return {
      dialogVisible: false,
      ruleForm: {
        channelUserId: "",
        note: "",
      },
      obj: {},
      page: 1,
      size: 10,
      arr: [],
      result: false,
    //   rules: {
    //     channelUserId: [
    //       {
    //         required: true,
    //         message: "请输入邀请人用户Id",
    //         trigger: "blur",
    //       },
    //       // { message: "请输入线路名称", trigger: "blur" },
    //     ],
    //     note: [{ required: true, message: "请输入渠道信息", trigger: "blur" }],
    //     channelCode: [
    //       { required: true, message: "请输入渠道编码", trigger: "blur" },
    //     ],

    //     lineUrl: [
    //       {
    //         required: true,
    //         validator: ValidateLineUrl,
    //         trigger: "blur",
    //       },
    //     ],
    //     financialUrl: [
    //       {
    //         required: true,
    //         validator: ValidateLineUrl,
    //         trigger: "blur",
    //       },
    //     ],
    //   },
    };
  },
  mounted() {
    console.log(this.$route.params);
    if(this.$route.params.id){
        console.log('this.',this.$route.params.id);
        this.getChannelInfo({page:1,size:10,id:this.$route.params.id})
    }
  },
  components: {
    PageNation
  },
  computed:{
    ...mapState('channel',['channeInfolist','infoTotal'])
  },
  methods: {
    ...mapActions("channel", [ "getChannelInfo"]),
    handleSave() {
      this.dialogVisible = false;
      this.$message.success("已添加");
    },
    handlePageChanged(e) {
      this.page = e.page;
      this.size = e.size;
      this.obj = { ...this.obj, ...e };
      this.getChannelInfo({ ...this.obj,id:this.$route.params.id });
    },
    closeDialog() {},
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const obj = {
            ...this.ruleForm,
            channelUserId: Number(this.ruleForm.channelUserId),
          };
          // this.$refs[formName].validate(async (val) => {
          const res = await this.addOne(obj);
          if (res.code == 0) {
            this.dialogVisible = false;
            this.getUrlList({ page: 1, size: 10, channelCode: "" });
            this.resetForm();
            this.$message.success("添加成功");
          } else {
            this.$message.error("添加失败，请重试");
          }
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="less" scoped></style>
